<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="40px">
    <el-col :span="24">
      <el-form-item label="经度" prop="longitude">
        <el-input v-model="form.longitude" placeholder="请输入坐标经度" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="纬度" prop="latitude">
        <el-input v-model="form.latitude" placeholder="请输入坐标纬度" />
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
var longreg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,15}|180)$/
var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,15}|[0-8]?\d{1}|90)$/
export default {
  data() {
    const validateLongitude = (rule, value, callback) => {
      //经度,整数部分为0-180小数部分为0到15位
      if (!longreg.test(value)) {
        callback(new Error('错误经度'))
      }
      callback()
    }
    const validateLatitude = (rule, value, callback) => {
      //纬度,整数部分为0-90小数部分为0到15位
      if (!latreg.test(value)) {
        callback(new Error('错误纬度'))
      }
      callback()
    }
    return {
      // 表单参数
      form: {},
      rules: {
        longitude: [
          { validator: validateLongitude, trigger: 'blur' },
          { validator: validateLongitude, trigger: 'change' }
        ],
        latitude: [
          { validator: validateLatitude, trigger: 'blur' },
          { validator: validateLatitude, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    setFrom(form) {
      this.form = form
    },

    getLongitude() {
      if (!longreg.test(this.form.longitude)) {
        return 'error'
      }
      return this.form.longitude
    },
    getLatitude() {
      if (!latreg.test(this.form.latitude)) {
        return 'error'
      }
      return this.form.latitude
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/Coordinates.vue